import { Component, OnInit, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import {
  OrganizationBudgetAvailability,
  OrganizationFinanceApiService,
  OrganizationFinanceBook
} from './organization-finance-api.service';

@Component({
  standalone: true,
  selector: 'ain-organization-finance-overview',
  imports: [FormsModule, TableModule, ButtonModule, InputTextModule],
  template: `
    <section class="feature-card">
      <h2>Organization Finance Overview</h2>
      <p>Read-only operational view for phase 10 rollout.</p>
      <p-table [value]="books()">
        <ng-template pTemplate="header">
          <tr><th>Code</th><th>Name</th><th>Currency</th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.code }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.currencyCode }}</td>
          </tr>
        </ng-template>
      </p-table>

      <div class="availability">
        <h3>Budget Availability</h3>
        @if (!budgetingEnabled()) {
          <p>Budgeting capability is disabled for this tenant.</p>
        } @else {
          <div class="toolbar">
            <input pInputText [(ngModel)]="budgetLineId" placeholder="Budget line id" />
            <button pButton type="button" label="Load" (click)="loadAvailability()"></button>
          </div>
          @if (availability()) {
            <ul>
              <li>Available: {{ availability()?.availableAmount }}</li>
              <li>Revised budget: {{ availability()?.revisedBudgetAmount }}</li>
              <li>Commitments: {{ availability()?.activeCommitmentAmount }}</li>
              <li>Actual posted: {{ availability()?.actualAmount }}</li>
            </ul>
          }
        }
      </div>
    </section>
  `,
  styles: [`
    .feature-card { background: var(--ain-color-surface); border-radius: 16px; padding: 24px; box-shadow: 0 12px 30px rgb(15 23 42 / 8%); display: grid; gap: 16px; }
    .toolbar { display: flex; gap: 8px; flex-wrap: wrap; }
    ul { margin: 0; padding-inline-start: 18px; }
  `]
})
export class OrganizationFinanceOverviewComponent implements OnInit {
  private readonly api = inject(OrganizationFinanceApiService);

  readonly books = signal<OrganizationFinanceBook[]>([]);
  readonly availability = signal<OrganizationBudgetAvailability | null>(null);
  readonly budgetingEnabled = signal(false);
  budgetLineId = '';

  ngOnInit(): void {
    this.api.listBooks().subscribe({ next: rows => this.books.set(rows) });
    this.api.getCapabilitySetting('financial-core.budgeting').subscribe({
      next: setting => this.budgetingEnabled.set(setting.isEnabled)
    });
  }

  loadAvailability(): void {
    if (!this.budgetingEnabled()) return;
    const id = this.budgetLineId.trim();
    if (!id) return;

    this.api.getBudgetAvailability(id).subscribe({
      next: row => this.availability.set(row)
    });
  }
}

